"use client";

import NavDesktop from './nav-desktop';
import NavMobile from './nav-mobile';


export default function Nav() {


    return (
        <nav>
            <NavDesktop />
            <NavMobile />
        </nav >

    );
};